import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Document = createSvgIcon(
  <path d="m15.841 0 5.909 5.91V24H2.25V0h13.591ZM12.75 2.25H4.5v19.5h15V9h-6.75V2.25Zm6.659 4.5L15 2.341V6.75h4.409Z" />,
  'Document'
);

export { Document };